export const INVALID_SESSION_EVENT = "xeno:invalid-session";

export type InvalidSessionReason = "expired" | "superseded" | "unknown";

const INVALID_TOKEN_RE = /unauthorized: invalid token|invalid token|jwt|expired/i;
const UNAUTHORIZED_RE = /^unauthorized(?::.*)?$/i;
const SESSION_SUPERSEDED_RE = /session[_ ]superseded|superseded/i;

export function isInvalidTokenError(error: unknown): boolean {
  if (error instanceof Error) return INVALID_TOKEN_RE.test(error.message);
  if (typeof error === "string") return INVALID_TOKEN_RE.test(error);
  return false;
}

export function isSessionSupersededError(error: unknown): boolean {
  if (error instanceof Error) return SESSION_SUPERSEDED_RE.test(error.message);
  if (typeof error === "string") return SESSION_SUPERSEDED_RE.test(error);
  return false;
}

export function isAuthError(error: unknown): boolean {
  if (isInvalidTokenError(error)) return true;
  if (isSessionSupersededError(error)) return true;
  if (error instanceof Error) return UNAUTHORIZED_RE.test(error.message);
  if (typeof error === "string") return UNAUTHORIZED_RE.test(error);
  return false;
}

export function isExpiredSession(session: { expires_at?: number | null } | null | undefined): boolean {
  if (typeof session?.expires_at !== "number") return false;
  return session.expires_at * 1000 <= Date.now();
}

export async function handleInvalidSession(reason: InvalidSessionReason = "unknown"): Promise<void> {
  if (typeof window === "undefined") return;

  try {
    const { clearLocalSessionId } = await import("./session-id");
    clearLocalSessionId();
  } catch {
    /* ignore */
  }

  try {
    const { supabase } = await import("@/integrations/supabase/client");
    await supabase.auth.signOut({ scope: "local" }).catch(() => undefined);
  } catch {
    /* ignore */
  }

  window.dispatchEvent(new CustomEvent(INVALID_SESSION_EVENT, { detail: { reason } }));
}
